'use strict';

angular.module('mean.contacts').factory('contactService', ['$filter', '$q', 'Users', 'Requests', 'Contacts',
    function($filter, $q, Users, Requests, Contacts) {

        var inRequestList = function(requestor, requestee, division) {
            var defer = $q.defer();

            Requests.query({'requestor': requestor, 'requestee': requestee, 'division': division},
                function(requests) {
                    defer.resolve(requests[0]);
            });

            return defer.promise;
        }

        var getMyContacts = function(user) {
            var defer = $q.defer();

            Contacts.query({'user': user}, function(contacts) {
                defer.resolve(contacts[0]);
            });

            return defer.promise;
        }

        var inContactList = function(owner, trade) {
            var array = username.split('', 9);
            var trade = array[0] + array[1];

            return (trade === '00');
        }

        return {
            inRequestList: inRequestList,
            getMyContacts: getMyContacts,
            inContactList: inContactList
        };
    }
]);



// WEBPACK FOOTER //
// ./packages/custom/contacts/public/services/contact-service.js